import { render } from "./NoteTaker.vue?vue&type=template&id=49438816&scoped=true"
import script from "./NoteTaker.vue?vue&type=script&lang=js"
export * from "./NoteTaker.vue?vue&type=script&lang=js"

import "./NoteTaker.vue?vue&type=style&index=0&id=49438816&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49438816"]])

export default __exports__